module.exports = __webpack_public_path__ + "static/media/person6.f4639160.svg";